import { IRescueData } from '../interfaces/rescue-data.interface';

export class RescueDataModel implements IRescueData {

  constructor(
        public number_id: string = '',
        public client_name: string = '',
        public client_lastname: string = '',
        public email: string = '',
        public mobile_number: string = '',
    ) {}
}
